module.exports = __webpack_public_path__ + "img/7.e3a2335e.jpg";